import RegisterForm from '../../components/auth/RegisterForm';
import { Link } from 'react-router-dom'; // Cambiar Link de next/link a react-router-dom
import React from 'react';

const RegisterPage = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <RegisterForm />
      <p style={{ marginTop: '10px' }}>
        ¿Ya tienes una cuenta? <Link to="/auth/login">Inicia Sesión</Link>
      </p>
    </div>
  );
};

export default RegisterPage;